<div appTheme class="message-box-container">
    <div class="message-box-header-container">
        {{title}}
        <div class="message-box-header-close-button"  id="closeBtn"
        (click)="activeModal.close(); onMessageBoxClosed()"><i class="fa fa-close"></i></div>
    </div>
    <div class="message-box-content">
        <div class="message-box-icon-container">
            <img class="message-box-icon" src="{{iconUrl}}">
        </div>
        <div class="message-box-text-container">
            <div class="message-box-text" [innerHtml]="message | innerHtmlStyle"></div>
        </div>
    </div>
    <hr class="message-box-separation-line">
    <div class="bottom message-box-button-container">
        <button *ngIf="buttonVisibility.cancel" id="cancel-button" class="cancel-button button-small " (click)="onButtonClicked(MessageBoxButton.Cancel)">Cancel</button>
        <button *ngIf="buttonVisibility.ok" id="ok-button" class="submit-button button-small" (click)="onButtonClicked(MessageBoxButton.Ok)">OK</button>
        <button *ngIf="buttonVisibility.yes" id="yes-button" class="submit-button button-small" (click)="onButtonClicked(MessageBoxButton.Yes)">Yes</button>
        <button *ngIf="buttonVisibility.no" id="no-button" class="cancel-button button-small " (click)="onButtonClicked(MessageBoxButton.No)">No</button>
    </div>
</div>
